import { isFocusable } from './is-focusable.js';

/**
 * @internal
 *
 * If you need access to the last focusable descendant of a container, you can use
 * `getLastFocusableChild`. The function uses the
 * https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker to
 * iterate over the children of the container and returns either a `Node` if a
 * focusable element is found, or `null`.
 */
export function getLastFocusableChild(container: HTMLElement): Node | null {
  const treeWalker = document.createTreeWalker(container);

  // Move the current node to the last node of the container.
  while (treeWalker.lastChild()) {
    treeWalker.lastChild();
  }

  // Iterate backwards over all the nodes inside the container and return the current node if it is focusable.
  do {
    if (isFocusable(treeWalker.currentNode)) {
      return treeWalker.currentNode;
    }
  } while (treeWalker.previousNode());

  return null;
}
